/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.multi.account.configuration.manager.rpc.MultiAccountConnectionsChirpService
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const hasDataSharingConnectionAsDestinationRpc = {
  serviceName: 'com.hubspot.multi.account.configuration.manager.rpc.MultiAccountConnectionsChirpService',
  rpcName: 'hasDataSharingConnectionAsDestination',
  auth: 'app',
  fingerprint: 'AAAAAAAAAABHiqXznGOFMpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getDataSharingSourceAccountsRpc = {
  serviceName: 'com.hubspot.multi.account.configuration.manager.rpc.MultiAccountConnectionsChirpService',
  rpcName: 'getDataSharingSourceAccounts',
  auth: 'app',
  fingerprint: 'AAAAAAAAAABBwgWM-NRY7pwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const hasCopyAssetConnectionAsSourceRpc = {
  serviceName: 'com.hubspot.multi.account.configuration.manager.rpc.MultiAccountConnectionsChirpService',
  rpcName: 'hasCopyAssetConnectionAsSource',
  auth: 'app',
  fingerprint: 'AAAAAAAAAADMDVseOL6c1JwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};